import { groupBy } from 'lodash';

import constants from './constants';
import sortUtils from './sortUtils';
import { DeviceDescriptor } from './records';

const { BRANDS, SORT_CATEGORIES, DEVICE_FORM_FACTOR } = constants;

const { FREE, OTHER, PHONES, PINNED, PRIVATE } = SORT_CATEGORIES;

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
const groupByBrand = (devices: DeviceDescriptor[]) => {
  const groupedByBrand = groupBy(devices, (device) => {
    const deviceManufacturer = device.manufacturers[0]?.toLowerCase();

    switch (deviceManufacturer) {
      case BRANDS.APPLE:
      case BRANDS.SAMSUNG:
      case BRANDS.GOOGLE:
        return deviceManufacturer;

      default:
        return BRANDS.OTHER;
    }
  });

  return {
    [BRANDS.APPLE]: (groupedByBrand[BRANDS.APPLE] ?? []).sort(sortUtils.sortByOsVersion),
    [BRANDS.SAMSUNG]: (groupedByBrand[BRANDS.SAMSUNG] ?? []).sort(sortUtils.sortByOsVersion),
    [BRANDS.GOOGLE]: (groupedByBrand[BRANDS.GOOGLE] ?? []).sort(sortUtils.sortByOsVersion),
    [BRANDS.OTHER]: groupedByBrand[BRANDS.OTHER] ?? [],
  };
};

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
const groupByCategory = (
  devices: DeviceDescriptor[],
  pinnedDeviceIds: string[],
) => {
  const groupedByCategory = groupBy(devices, (device) => {
    if (device.isFreeTrialDevice()) {
      return FREE;
    }

    if (pinnedDeviceIds.includes(device.compositeId)) {
      return PINNED;
    }

    if (device.isPrivateDevice()) {
      return PRIVATE;
    }

    if (device.formFactor === DEVICE_FORM_FACTOR.PHONE) {
      return PHONES;
    }

    // for now, only tablets should go here
    // but when new "kinds" of devices are introduced, they will end here as well
    return OTHER;
  });

  const groupedPhonesByBrand = groupByBrand(groupedByCategory[PHONES]);

  return {
    [FREE]: groupedByCategory[FREE] ?? [],
    [PINNED]: (groupedByCategory[PINNED] ?? []).sort(sortUtils.sortPrivateFirst),
    [PRIVATE]: groupedByCategory[PRIVATE] ?? [],
    [PHONES]: [
      ...groupedPhonesByBrand[BRANDS.APPLE],
      ...groupedPhonesByBrand[BRANDS.SAMSUNG],
      ...groupedPhonesByBrand[BRANDS.GOOGLE],
      ...groupedPhonesByBrand[BRANDS.OTHER],
    ],
    [OTHER]: groupedByCategory[OTHER] ?? [],
  };
};

export default {
  groupByBrand,
  groupByCategory,
};
